import React from "react";
import "./Portfolio.css";
import connectBg from "../assets/connect-bg.jpg"; // update path if needed

const Portfolio = () => {
  return (
    <section id="connect"
      className="connect-section"
      style={{ backgroundImage: `url(${connectBg})` }}
    >
      <div className="overlay"></div>

      <div className="connect-content">
        <h2>Connect With Us!</h2>

        <ul>
          <li>To keep up with the latest trends in digital</li>
          <li>To see glimpses of our work</li>
          <li>To see what’s up with our staff</li>
        </ul>

        <div className="btn-group">
          <a
            href="https://www.linkedin.com/company/vibewebmedia"
            target="_blank"
            rel="noreferrer"
            className="btn linkedin"
          >
            CONNECT WITH US!
          </a>

          <a
            href="https://instagram.com"
            target="_blank"
            rel="noreferrer"
            className="btn instagram"
          >
            FOLLOW US NOW!
          </a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;